"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FILTERS = void 0;
var _filters = require("../types/filters");
const FILTERS = {
  [_filters.EFilters.HOUSE]: 'Дома',
  [_filters.EFilters.TOWNHOUSE]: 'Таунхаусы',
  [_filters.EFilters.LAND]: 'Участки'
};
exports.FILTERS = FILTERS;